// eslint-disable-next-line import/no-cycle
import useApiHelpers from './helpers';

const { getRequest } = useApiHelpers();

export const getCountries = async () => getRequest('/countries');
export const getSubdivisions = async (countryCode) => getRequest(`/countries/subdivisions/${countryCode}`);
